// extracted by mini-css-extract-plugin
export default {"product_buttons":"products_product_buttons__eZnAG","search_container":"products_search_container__VSHFZ"};